import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { get, filter, find, camelCase } from 'lodash'
import ActionTypes from '@constants/action_types.js'

const viewsAdapter = createEntityAdapter()

// create initial state for the views slice and include a view to act as the default view
const initialState = viewsAdapter.getInitialState({
  ids: [],
  entities: {},
})

const viewsSlice = createSlice({
  name: 'views',
  initialState,
  extraReducers: builder => {
    builder.addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => {
      const { payload } = action
      if (payload.hasOwnProperty('views')) {
        viewsAdapter.upsertMany(state, payload.views)
      }
    })
  },
})

// Selectors

export const viewsSelectors = viewsAdapter.getSelectors(state => state.data.views)

export const getView = (state, props) => {
  const { viewId } = props

  if (!viewId) {
    return undefined
  }
  const allViews = viewsSelectors.selectAll(state)
  return find(allViews, view => {
    const result = view.id.toString() === viewId.toString()
    return result
  })
}

// Dips into state to get view variant, the specific view type (e.g. grid, stack, etc.)
// Note: Looks for the variant type in the view's relationships and
// then selects from variant-specific reducer node (e.g. state.data.gridViews)
export const getViewVariant = (state, props) => {
  const { viewId } = props
  const view = viewsSelectors.selectById(state, viewId)
  if (!view) {
    console.warn('Unable to find base view in state')
    return null
  }
  const variantData = get(view, ['relationships', 'variant', 'data'])
  // turns stack_views into stackViews, which is the node name in state
  if (!variantData) {
    console.warn('Unable to find variant data in state')
    return null
  }

  const variantType = get(variantData, 'type')
  const variantNodeName = camelCase(variantType)
  const entityReducerNode = get(state, ['data', variantNodeName])

  let variantEntity = null
  if (!entityReducerNode) {
    console.warn(`Unable to find a node in store data for variants: '${variantNodeName}'`)
  } else {
    variantEntity = get(entityReducerNode, ['entities', variantData.id])
  }

  if (!variantEntity) {
    console.warn('Unable to find variant entity in state')
  }
  return variantEntity
}

export const getViewsForTable = (state, props) => {
  const { tableId } = props
  const tableIdString = tableId.toString()
  const allViews = viewsSelectors.selectAll(state)
  return filter(allViews, view => {
    const viewTableId = get(view, ['attributes', 'table_id'])
    const viewTableIdString = viewTableId.toString()
    return viewTableIdString === tableIdString
  })
}

export default viewsSlice.reducer
